
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/for-enterprise",
      function () {
        return require("private-next-pages/solutions/for-enterprise.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/for-enterprise"])
      });
    }
  